import React from 'react';
import { motion } from 'framer-motion';
import { Book, Image as ImageIcon, CheckCircle } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'Gestión de Carrera y Consultorio Particular',
  desc: 'Marca personal, modelo de negocio y estructura de consultorio rentable para el kinesiólogo independiente.'
}, {
  num: '2',
  title: 'Evaluación Clínica Funcional: Protocolos de Ingreso',
  desc: 'Fichas de evaluación inicial, tests funcionales y diagnóstico kinésico sistematizado.'
}, {
  num: '3',
  title: 'Traumatología I: Miembro Superior',
  desc: 'Protocolos de rehabilitación para hombro, codo y muñeca. Fase por fase, con criterios de progresión.'
}, {
  num: '4',
  title: 'Traumatología II: Miembro Inferior',
  desc: 'Rehabilitación de rodilla, tobillo y cadera. Desde la fase aguda hasta el retorno deportivo.'
}, {
  num: '5',
  title: 'Ortopedia y Columna: Abordaje Práctico',
  desc: 'Lumbalgias, cervicalgias, escoliosis y hernias. El protocolo más usado del consultorio, sistematizado.'
}, {
  num: '6',
  title: 'Internación Domiciliaria: Protocolos de Seguridad',
  desc: 'Manejo del paciente en domicilio. Protocolos de crisis, transferencias y comunicación con familia.'
}, {
  num: '7',
  title: 'Auditoría: Informes de Evolución para Obras Sociales',
  desc: 'Plantillas de informes irrefutables para OSDE, Swiss Medical, PAMI y las principales obras sociales.'
}, {
  num: '8',
  title: 'Gestión de Agenda: Optimización de Turnos',
  desc: 'Sistema de turnos, política de cancelaciones y reducción de baches en la agenda.'
}, {
  num: '9',
  title: 'Seguimiento: Tableros de Progresión de Pacientes',
  desc: 'Herramientas para medir y mostrar la evolución clínica objetiva de cada paciente.'
}, {
  num: '10',
  title: 'Documentación Legal: Consentimientos y Fichas',
  desc: 'Consentimientos informados, fichas clínicas y documentación que protege tu matrícula.'
}, {
  num: '11',
  title: 'Ejercicios Listos para Entregar al Paciente',
  desc: 'Prescripción domiciliaria en PDF. El paciente se lleva su rutina impresa desde el primer día.'
}, {
  num: '12',
  title: 'Cierre de Tratamiento: Criterios de Alta',
  desc: 'Protocolo de alta kinésica, informe final y portfolio de resultados clínicos.'
}];
const bonuses = [{
  emoji: '💰',
  title: 'Calculadora de Valor Real de Sesión',
  desc: 'Calculá exactamente cuánto tenés que cobrar para que tu consultorio sea rentable. Sin adivinar. Sin perder plata.',
  cover: 'bg-teal-700',
  spine: 'bg-teal-900'
}, {
  emoji: '📋',
  title: 'Nomenclador Rápido de Facturación',
  desc: 'Los códigos de facturación más usados por especialidad. Facturá bien desde el primer día y evitá rechazos.',
  cover: 'bg-amber-600',
  spine: 'bg-amber-800'
}, {
  emoji: '⚡',
  title: 'Manual de Implementación en 48hs',
  desc: 'Cómo aplicar el sistema completo en tu consultorio en un fin de semana. Sin caos, sin abrumarte.',
  cover: 'bg-sky-700',
  spine: 'bg-sky-900'
}, {
  emoji: '📱',
  title: 'Scripts de WhatsApp Business',
  desc: 'Mensajes listos para confirmar turnos, manejar cancelaciones y recuperar pacientes perdidos.',
  cover: 'bg-emerald-700',
  spine: 'bg-emerald-900'
}, {
  emoji: '📲',
  title: 'Kit de Autoridad Digital',
  desc: 'Configurá tu perfil de Google My Business e Instagram para que los pacientes te encuentren y te elijan.',
  cover: 'bg-rose-700',
  spine: 'bg-rose-900'
}, {
  emoji: '🔄',
  title: 'Manual de Recupero de Pacientes',
  desc: 'El sistema para reconectar con pacientes que abandonaron y convertirlos en altas reales.',
  cover: 'bg-slate-700',
  spine: 'bg-slate-900'
}];
export const Tomos = () => {
  return <section className="py-20 bg-slate-50 px-4 sm:px-6 lg:px-8" data-id="element-191">
      <div className="max-w-7xl mx-auto" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-194">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-slate-600 font-medium" data-id="element-195">
            Protocolos graficados · Por especialidad y fase · Listo para usar
            mañana
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-196">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:border-teal-300 hover:shadow-md transition-all" data-id="element-197">
              <div className="flex items-center gap-3 mb-4" data-id="element-198">
                <div className="bg-teal-100 text-teal-800 font-black text-xl w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-199">
                  T{tomo.num}
                </div>
                <h3 className="font-bold text-lg text-slate-900 leading-tight" data-id="element-200">
                  {tomo.title}
                </h3>
              </div>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-201">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4" data-id="element-202">
          <span className="bg-white border border-slate-200 text-slate-700 px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-203">
            ✏️ Protocolos graficados en cada tomo
          </span>
          <span className="bg-white border border-slate-200 text-slate-700 px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-204">
            ⚡ Sistema "Abrí y Aplicás"
          </span>
          <span className="bg-white border border-slate-200 text-slate-700 px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-205">
            📋 Plantillas listas para imprimir
          </span>
          <span className="bg-white border border-slate-200 text-slate-700 px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-206">
            🇦🇷 Contenido 100% adaptado a Argentina
          </span>
        </div>
      </div>
    </section>;
};
export const Bonus = () => {
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8 border-t border-slate-200" data-id="element-207">
      <div className="max-w-7xl mx-auto" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-210">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-slate-600 mb-6" data-id="element-211">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-block bg-red-100 text-red-700 border border-red-200 font-black px-6 py-2 rounded-full text-lg animate-pulse" data-id="element-212">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-213">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow p-8 flex flex-col items-center text-center" data-id="element-214">
              {/* Book cover mockup */}
              <div className="relative w-40 aspect-[3/4] mb-5" data-id="element-215">
                <div className={`absolute inset-0 ${bonus.cover} rounded-r-lg rounded-l-sm shadow-xl overflow-hidden flex flex-col p-5`} data-id="element-216">
                  {/* Spine */}
                  <div className={`absolute top-0 left-0 h-full w-3 ${bonus.spine}`} data-id="element-217"></div>
                  <span className="text-3xl mb-auto" aria-hidden="true" data-id="element-218">
                    {bonus.emoji}
                  </span>
                  <span className="text-white font-bold text-lg leading-tight text-left" data-id="element-219">
                    Bonus {i + 1}
                  </span>
                  <div className="border-t border-white/30 my-3" data-id="element-220"></div>
                  <span className="text-white/70 text-[10px] font-semibold tracking-widest uppercase text-left" data-id="element-221">
                    Kinesiología Práctica™
                  </span>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block bg-emerald-100 text-emerald-700 font-bold text-xs px-4 py-1.5 rounded-full mb-4 uppercase tracking-wide" data-id="element-222">
                Gratis
              </span>

              <h3 className="font-bold text-lg text-slate-900 mb-3 leading-tight" data-id="element-223">
                <span className="mr-1" data-id="element-224">{bonus.emoji}</span> Bonus {i + 1} —{' '}
                {bonus.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-225">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export const EliteUpsell = () => {
  return <section className="py-16 bg-slate-900 text-white px-4 sm:px-6 lg:px-8" data-id="element-226">
      <div className="max-w-5xl mx-auto" data-id="element-227">
        <div className="text-center mb-12" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-229">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-xl text-slate-300" data-id="element-230">
            Por solo $7.000 más, llevás tu práctica clínica al siguiente nivel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-231">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800 rounded-2xl p-8 border border-slate-700 relative overflow-hidden" data-id="element-232">
            <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl" data-id="element-233"></div>
            <h3 className="text-2xl font-bold mb-4 flex items-center gap-3" data-id="element-234">
              <span className="text-3xl" data-id="element-235">🧠</span> Élite 1 — El Detective
              Clínico
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-236">
              Protocolo de Diagnóstico Diferencial para casos que no avanzan.
              Tests de exclusión para lumbalgias y cervicalgias crónicas. Sé el
              profesional que encuentra la causa real donde otros solo ven el
              síntoma. 100 variantes de evaluación listas para aplicar. No
              improvises más ante el caso difícil.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800 rounded-2xl p-8 border border-slate-700 relative overflow-hidden" data-id="element-237">
            <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl" data-id="element-238"></div>
            <h3 className="text-2xl font-bold mb-4 flex items-center gap-3" data-id="element-239">
              <span className="text-3xl" data-id="element-240">🛡️</span> Élite 2 — Manual de
              Prescripción Quirúrgica
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-241">
              Tu guía de seguridad clínica absoluta para post-operatorios.
              Protocolos fase por fase para Rodilla (LCA/Prótesis), Hombro y
              Cadera. Criterios biológicos de carga. Detección de complicaciones
              antes que el médico. Trabajá con la seguridad de un especialista.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};